import { render, staticRenderFns } from "./issue_board_filtered_search.vue.js?vue&type=template&id=efc5e982&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_board_filtered_search.vue?vue&type=template&id=efc5e982&vue3"
import script from "./issue_board_filtered_search.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_board_filtered_search.vue?vue&type=script&lang=js&vue3"
export * from "./issue_board_filtered_search.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_board_filtered_search.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports